import { Component, OnInit, Input, NgZone, ViewChild } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { RestApiService } from "../../shared/rest-api.service";
import { CaptchaService } from "../../shared/captcha.service";
import { Title } from "@angular/platform-browser";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CaptchaComponent } from 'angular-captcha'; 
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ReCaptchaService } from 'angular-recaptcha3';
import { WhiteSpaceValidator } from './whitespace.validator';

declare let $: any;

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css']
})
export class ContactComponent implements OnInit {
	
	contactForm: FormGroup;
	submitted = false;
	public isDisabled = false;
	
	constructor(
		public restApi: RestApiService, 
		public captchaApi: CaptchaService,
		public router: Router,
		public route: ActivatedRoute,
		public ngZone: NgZone,
		private titleService:Title,
		private formBuilder: FormBuilder,
		private http: HttpClient,
		private recaptchaService: ReCaptchaService
	) {
		this.titleService.setTitle("Contact");
	}
	
	// Http Options
	httpOptions = {
		headers: new HttpHeaders({
			'Content-Type': 'application/json',
			'Access-Control-Allow-Origin': '*'
		})
	}
	
	@Input() contactDetails = { contactName: '', contactEmail: '', orgName: '', designation: '', contactNumber : '', token : '' , enquiryType: '',comments:''
	}
	
	/**
	* BotDetect CAPTCHA component.
	*/
	@ViewChild(CaptchaComponent, { static: true }) captchaComponent: CaptchaComponent;

	login() {
		 this.recaptchaService.execute({action: 'login'}).then(token => {
		   // Backend verification method
		   //this.sendTokenToBackend(token);
		   //console.log('token :', token);
		 });
	}
	
	ngOnInit(): void {
		this.loadScript('https://www.google.com/recaptcha/api.js?render=6LdHqsQdAAAAANKkSvJmHs-bmnfoJHdgjqQbC-hE');
		this.contactForm = this.formBuilder.group({
            contactName: ['', [Validators.required, Validators.pattern('[a-zA-Z\. ]*$'), Validators.maxLength(50), WhiteSpaceValidator.noWhiteSpace]],
			//contactEmail: ['', [Validators.required, Validators.email, Validators.pattern('^[a-z0-9._+-]+@[a-z0-9.-]+\.[a-z]{2,4}$')]],
			contactEmail: ['', [Validators.required, Validators.pattern('^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\.[a-z]{2,4}$')]],
			// contactNumber: ['', [Validators.required, Validators.number, Validators.minLength(10), Validators.maxLength(10)]],
			contactNumber: ['', [Validators.required, Validators.pattern("[0-9]{10}")]],
			orgName: ['', [Validators.required, Validators.pattern('[a-zA-Z0-9&. ]*$'), Validators.maxLength(100), WhiteSpaceValidator.noWhiteSpace ]],
			designation: ['', [Validators.pattern('[a-zA-Z&. ]*$'), Validators.maxLength(100), WhiteSpaceValidator.noWhiteSpace]],
			token: [''], // we will validate captcha input value at the backend side
			enquiryType: ['', Validators.required],
			comments:['', [Validators.pattern('[a-zA-Z&. ]*$'), Validators.maxLength(500), WhiteSpaceValidator.noWhiteSpace ]],
        });
	}
	
	
	public loadScript(url: string) {
		const body = <HTMLDivElement> document.body;
		const script = document.createElement('script');
		script.innerHTML = '';
		script.src = url;
		script.async = false;
		script.defer = true;
		body.appendChild(script);
	}

	// convenience getter for easy access to form fields
    get f() { return this.contactForm.controls; }
	
	onSubmit() {
		
		this.submitted = true;
		// stop here if form is invalid
		if (this.contactForm.invalid) {
			return;
		} else {
			this.isDisabled = true;
			this.recaptchaService.execute({action: 'Enquiry'}).then(token => {
				const postData = {
					token : token
				}
				this.restApi.verifyCaptcha(this.contactDetails).subscribe((data: any) => {
					console.log('data :', data);
					if(data[0].result == 'invalidToken') {
						window.alert('Invalid request. Please try again!');
						this.router.navigate(["/contact"]);
						this.isDisabled = false;
					} else if(data[0].result == 'fieldMissing') {
						window.alert('something went wrong. Please try again!');
						this.isDisabled = false;
					} else if(data[0].result == 'failed') {
						window.alert('something went wrong. Please try again!');
						this.isDisabled = false;
					} else {
						window.alert('Enquiry Sent Successfully');
						this.router.navigate(["/"]);
					}
				})
			});
		}
        //alert('SUCCESS!! :-)')
    }
	
	onTriggerCaptchaReload() {
		let jsScript = document.createElement("script");
		jsScript.type = "text/javascript";
		jsScript.async = true;
		jsScript.innerHTML  = "$('.BDC_ReloadIcon').trigger('click');";
		document.body.appendChild(jsScript);
	}
	
	ngAfterViewInit(): void {
		setTimeout(function () {
			$.getScript('assets/scripts/jquery-3.3.1.js', function(){});
			let jsScript = document.createElement("script");
			jsScript.type = "text/javascript";
			jsScript.async = true;
			jsScript.innerHTML  = "$(document).ready(function () {   $('a').mouseover(function(){ $(this).prop('title',''); }); $('.grecaptcha-badge').show(); });";
			document.body.appendChild(jsScript); 
		},400);
	}

	onCaptchaExpired(event) {
		console.log('token2 : ',event);
	}

	onCaptchaResponse(event) {
		console.log(event);
		this.contactForm.controls['token'].setValue(event);
		this.contactForm.controls['token'].patchValue(event);
	}
	
	
	/*
	ngAfterContentChecked(): void {
		$.getScript('assets/scripts/jquery-3.3.1.js', function(){});
		let jsScript = document.createElement("script");
		jsScript.type = "text/javascript";
		jsScript.async = true;
		jsScript.innerHTML  = "$(document).ready(function () { $('#angularBasicCaptcha_HelpLink').mouseover(function(){ console.log('alert'); }); });";
		document.body.appendChild(jsScript); 	
	}
	*/

}
